import { type FunctionComponent } from 'react';
// Material UI imports
import { type TypographyProps } from '@mui/material/Typography';
import AlertTitle, { type AlertTitleProps } from '@mui/material/AlertTitle';

const AlertTitleTypography = AlertTitle as FunctionComponent<AlertTitleProps & TypographyProps>;

export default AlertTitleTypography;
